import { RefObject, useCallback, useEffect, useState } from 'react';

export const useScrollPercentage = (
  containerRef: RefObject<HTMLElement>,
  isVisible?: boolean,
): { scrollPercentage: number } => {
  const [scrollPercentage, setScrollPercentage] = useState(0);

  const handleScroll = useCallback(() => {
    const container = containerRef.current;

    if (container) {
      const begin = window.scrollY + window.innerHeight - container.offsetTop;

      setScrollPercentage(Math.round((begin * 100) / container.clientHeight));
    }
  }, [containerRef]);

  useEffect(() => {
    if (isVisible) {
      document.addEventListener('scroll', handleScroll, { passive: true });
    } else {
      document.removeEventListener('scroll', handleScroll);
    }

    return () => document.removeEventListener('scroll', handleScroll);
  }, [containerRef, handleScroll, isVisible]);

  return { scrollPercentage };
};
